module.exports = __webpack_public_path__ + "img/play_button.2017a9c8.gif";